import React from 'react';
export const DowngradeModalContext = /*#__PURE__*/React.createContext({});
//# sourceMappingURL=DowngradeModalContext.js.map